import * as React from 'react';
const DashboardIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...props}>
    <path
      fill={props.color}
      d="M15.833 7.417V1.75C15.833.5 15.3 0 13.975 0h-3.367C9.283 0 8.75.5 8.75 1.75v5.667c0 1.25.533 1.75 1.858 1.75h3.367c1.325 0 1.858-.5 1.858-1.75ZM7.083 9.25v5.667c0 1.25-.533 1.75-1.858 1.75H1.858c-1.325 0-1.858-.5-1.858-1.75V9.25C0 8 .533 7.5 1.858 7.5h3.367c1.325 0 1.858.5 1.858 1.75ZM15.833 14.92v-2.334c0-1.25-.533-1.75-1.858-1.75h-3.367c-1.325 0-1.858.5-1.858 1.75v2.333c0 1.25.533 1.75 1.858 1.75h3.367c1.325 0 1.858-.5 1.858-1.75ZM7.083 4.083V1.75C7.083.5 6.55 0 5.225 0H1.858C.533 0 0 .5 0 1.75v2.333c0 1.25.533 1.75 1.858 1.75h3.367c1.325 0 1.858-.5 1.858-1.75Z"
    />
  </svg>
);
export default DashboardIcon;
